import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { LogoIcon } from '../../assets/icons';
import routes from '../../routes';

const Logo = ({ title }) => {
  return (
    <div className='primary__menu__top__logo'>
      <Link to={routes.websites}>
        <img src={LogoIcon} alt='' title={title} />
      </Link>
    </div>
  );
};

Logo.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Logo;
